import 'reflect-metadata';
import 'regenerator-runtime';
import 'url-search-params-polyfill';
import './localisation';
import './index.scss';
import '@platform/elements/esm/index.css';
import '@interhyp/module-case-assignment/esm/index.css';
import '@interhyp/module-communication/esm/index.css';
import '@interhyp/module-documents/esm/index.css';
import '@interhyp/platform-navigation/esm/index.css';
import '@interhyp/platform-layout/esm/index.css';

import { init } from '@interhyp/util-tracking';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { AppWithRouterAndContext } from './App';
import { unregister } from './serviceWorkerRegistration';

import './util/logging';

init();

const root = createRoot(document.querySelector('#root'));
root.render(<AppWithRouterAndContext />);

unregister();
